<svg fill="none" width="58" height="57" class="user-select-none cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 57">
  <circle cx="30.9961" cy="28.0547" r="15" fill="#fff" />
  <circle cx="40.4961" cy="18.5547" r="9.5" fill="#0B292F" />
  <mask id="a" fill="#fff">
    <path
      d="M5.70584 24.3364c-.49474-.0791-.83338-.5448-.73604-1.0363
      1.07334-5.4191 3.94965-10.3265 8.174-13.91399 4.4553-3.78356
      10.1165-5.84961 15.9616-5.82515 5.845.02446 11.4887 2.13782 15.9122
      5.95854 4.1942 3.6227 7.0293 8.554 8.0573
      13.9819.0932.4923-.2493.9552-.7447
      1.0301-.4954.075-.9559-.2664-1.0506-.7584-.9622-4.9999-3.5814-9.5408-7.448-12.8805-4.0959-3.53779-9.3216-5.49464-14.7338-5.51729-5.4122-.02265-10.6541
      1.8904-14.7795 5.39379-3.8944 3.3072-6.55153 7.826-7.55557
      12.8177-.0988.4912-.56215.8287-1.05689.7496Z" />
  </mask>
  <path
    d="M5.70584 24.3364c-.49474-.0791-.83338-.5448-.73604-1.0363 1.07334-5.4191
    3.94965-10.3265 8.174-13.91399 4.4553-3.78356 10.1165-5.84961
    15.9616-5.82515 5.845.02446 11.4887 2.13782 15.9122 5.95854 4.1942 3.6227
    7.0293 8.554 8.0573 13.9819.0932.4923-.2493.9552-.7447
    1.0301-.4954.075-.9559-.2664-1.0506-.7584-.9622-4.9999-3.5814-9.5408-7.448-12.8805-4.0959-3.53779-9.3216-5.49464-14.7338-5.51729-5.4122-.02265-10.6541
    1.8904-14.7795 5.39379-3.8944 3.3072-6.55153 7.826-7.55557
    12.8177-.0988.4912-.56215.8287-1.05689.7496Z"
    stroke="#fff"
    stroke-width="4"
    mask="url(#a)" />
  <rect
    x="1.99609"
    y="2.46875"
    width="2"
    height="72.4096"
    rx="1"
    transform="rotate(-45 1.99609 2.46875)"
    fill="#000" />
  <rect
    x="2.99609"
    y="1.46875"
    width="2"
    height="72.4096"
    rx="1"
    transform="rotate(-45 2.99609 1.46875)"
    fill="#fff" />
</svg>
